import { useState, useContext } from "react"
import { UIContext } from "../layout"

const useLightboxManager = () => {
  const [showLightbox, _setShowLightbox] = useState(false)
  const [lightboxIndex, setLightboxIndex] = useState(0)
  const { dispatch } = useContext(UIContext)

  const toggleLightbox = index => {
    _setShowLightbox(prevState => {
      if (index !== undefined && index !== null) {
        setLightboxIndex(index)
      }

      const newValue = !prevState
      dispatch(prevState => {
        return { ...prevState, disableBodyScroll: newValue }
      })
      return newValue
    })
  }

  return [showLightbox, toggleLightbox, lightboxIndex]
}

export default useLightboxManager
